import { toaster } from "Helpers/toaster";
import useSession from "Hooks/session.hook";
import { useState } from "react";
import {
  createArchiveOrders,
  listArchiveOrders,
  revertArchiveOrders,
  fetchArchiveSettings,
  createArchiveSetting,
  updateArchiveSettings,
} from "Services/order.service";
import { isEmpty, isNil, omitBy, pick } from "lodash";

interface useArchiveOrdersProps {
  fetchOrders: () => Promise<void>;
  filterObj: any;
}

export const useArchiveOrders = ({
  fetchOrders,
  filterObj,
}: useArchiveOrdersProps) => {
  const [isArchive, setIsArchive] = useState(false);
  const [archivedOrdersList, setArchivedOrdersList] = useState<any>([]);
  const [archiveSettings, setArchiveSettings] = useState<any>([]);
  const { org } = useSession();

  const handleSetArchiveOrders = async (selectedRows: any[]) => {
    if (!isEmpty(selectedRows)) {
      const orders = selectedRows?.flatMap((order) => [
        order?._id,
        ...(order?.childrenOrderIDs || []),
      ]);
      const responseData = await createArchiveOrders(orders);

      if (responseData && !responseData.error) {
        toaster("success", "Orders are successfully archived.");
        fetchOrders && fetchOrders();
      } else {
        toaster("error", "Orders failed to archive.");
      }
    } else {
      toaster("info", "Select at least one order to archive.");
    }
  };

  const handleListArchivedOrders = async () => {
    let adjustedFilters = omitBy(
      { ...filterObj, companyOrgID: org._id, orgID: null, orderStatus: null },
      isNil,
    );

    adjustedFilters = pick(adjustedFilters,[
      "companyOrgID",
      "customerOrgID",
      "ancestorOrgIDs",
      "orFields"
    ])

    const responseData: any = await listArchiveOrders(adjustedFilters);

    if (!isNil(responseData.data) && !responseData.error) {
      setArchivedOrdersList &&
        setArchivedOrdersList(responseData.data.orderArchives);
    }
  };

  const handleRevertArchivedOrders = async (orderIDs: string[]) => {
    const responseData: any = await revertArchiveOrders(orderIDs);

    if (!isNil(responseData.data) && !responseData.error) {
      toaster("success", "Order has been placed in Diolko Review.");
      handleListArchivedOrders();
    } else {
      toaster("error", "Failed to revert archive order.");
    }
  };

  const handleFetchArchiveSettings = async (orgID: string) => {
    const responseData: any = await fetchArchiveSettings(org._id);

    if (!isNil(responseData.data) && !responseData.error) {
      setArchiveSettings &&
        setArchiveSettings(responseData.data?.archiveSetting[0]);
    } else {
      toaster("error", "Failed to fetch archive settings.");
    }
  };

  // const handleCreateArchiveSettings = async (archiveSettingsData) => {
  //   const responseData = await createArchiveSetting(archiveSettingsData);

  //   if (!isNil(responseData.data) && !responseData.error) {
  //     toaster("success", "Archive created successfully");
  //     handleFetchArchiveSettings(org._id);
  //   } else {
  //     toaster("error", responseData.error.message.message);
  //   }
  // };

  // const handleUpdateArchiveSettings = async (archiveSettingsData) => {
  //   const responseData: any = await updateArchiveSettings(archiveSettingsData);

  //   if (!isNil(responseData.data) && !responseData.error) {
  //     toaster("success", "Archive updated successfully");
  //     handleFetchArchiveSettings(org._id);
  //   } else {
  //     toaster("error", responseData.error.message.message);
  //   }
  // };

  return {
    allArchiveObjects: {
      archiveSettingsObject: { archiveSettings, setArchiveSettings },
      archiveStateObject: { isArchive, setIsArchive, archivedOrdersList },
      handleSetArchiveOrders,
      handleListArchivedOrders,
      handleRevertArchivedOrders,
      handleFetchArchiveSettings,
      // modifySettingsFunctions: {
      //   handleCreateArchiveSettings,
      //   handleUpdateArchiveSettings,
      // },
    },
  };
};
